import React from "react";
import translationText from "../../translation.js";
import { Col, Container, Row } from "react-bootstrap";
import { useGetLocalText } from "../../utils.js";
import { Link } from "react-router-dom";
import Page from "../../common/component/fragments/Page.jsx";

const RenderTitle = ({ titleKey, link, as }) => {
  const { title } = useGetLocalText(titleKey, ["title"]);

  return (
    <p
      style={{
        borderRadius: 10,
        color: "#ffffff",
        fontSize: "1rem",
        fontWeight: "bold",
        boxShadow: "0px 3px 6px #00000029",
      }}
      className="py-4 w-100 text-center"
    >
      {as === "a" ? (
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#FAA652" }}
        >
          {title}
        </a>
      ) : (
        <Link to={link} style={{ color: "#FAA652" }}>
          {title}
        </Link>
      )}
    </p>
  );
};

const CrimeReview = () => (
  <Page pageTitle={translationText.PassPortVerification}>
    <Container className="mt-4">
      <Row>
  <div style={{ width: "100%", height: "90vh" }}>
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSdzRiLiA9EdRWUpb1gn7jeNqsi8_SKa-9zKqBs6nOHfszfKAQ/viewform?embedded=true"
          width="100%"
          height="100%"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          title="Crime Review Form"
        >
          Loading…
        </iframe>
      </div>
      </Row>
    </Container>
  </Page>
);

export default CrimeReview;
